import {
  ChangeDetectorRef,
  Component,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { routeAnimations } from '@app/animations';
import { BottomTabNavComponent } from '../../bottom-tab-nav/bottom-tab-nav.component';
import { MobileHeaderComponent } from '../../mobile-header/mobile-header.component';
import { SwipeBackDirective } from '@app/directives/swipe-back.directive';
import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-mobile-layout',
  imports: [
    RouterOutlet,
    MobileHeaderComponent,
    BottomTabNavComponent,
    SwipeBackDirective,
    FooterComponent,
  ],
  templateUrl: './mobile-layout.component.html',
  styleUrls: ['./mobile-layout.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  animations: [routeAnimations],
})
export class MobileLayoutComponent {
  animationState: number | undefined;

  constructor(private cdRef: ChangeDetectorRef) {}

  onOutletLoaded(outlet: RouterOutlet) {
    if (outlet && outlet.component) {
      this.animationState = outlet.activatedRouteData?.['depth'] ?? 0;
      this.cdRef.detectChanges();
    }
  }
}
